<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelStatusBilhete"
    :multiple="true"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :close-on-select="false"
    :hide-selected="true"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }">
      <span
        v-b-tooltip.hover
        :title="option.nome"
        :class="`badge badge-${getStatusClass(option.id)} badge-sm mr-1 d-inline-flex align-items-center`"
        style="padding: 4px 6px"
      >
        <b-icon :icon="getStatusIcon(option.id)" font-scale="1" />
        <span class="custom__remove-icon" @mousedown.prevent.stop="removeOption(option)">×</span>
      </span>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div class="d-flex align-items-center">
        <span
          v-if="option.id !== null"
          :class="`badge badge-${getStatusClass(option.id)} badge-sm mr-2 d-inline-flex align-items-center`"
          style="padding: 4px 6px"
        >
          <b-icon :icon="getStatusIcon(option.id)" font-scale="0.85" />
        </span>
        <span>{{ option.nome }}</span>
      </div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll'],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false,
      allOption: null,
      statusConfig: {
        1: { class: 'primary', icon: 'clock-fill' },
        2: { class: 'danger', icon: 'dash-circle-fill' },
        3: { class: 'success', icon: 'star-fill' },
        4: { class: 'danger', icon: 'star-fill' },
        5: { class: 'dark', icon: 'x-circle-fill' },
        6: { class: 'warning', icon: 'cash-stack' },
        7: { class: 'warning', icon: 'star-half' }
      }
    };
  },

  methods: {
    getStatusClass(id) {
      return this.statusConfig[id]?.class || 'secondary';
    },
    getStatusIcon(id) {
      return this.statusConfig[id]?.icon || 'question-circle-fill';
    },
    onChange(e) {
      // Se selecionou a opção "Todos"
      if (e && e.length > 0) {
        const hasAllOption = e.find((item) => item.id === null);

        if (hasAllOption && this.selected.length !== this.options.length) {
          // Selecionou "Todos" - selecionar todos os status (exceto a opção "Todos")
          this.selected = this.options.filter((opt) => opt.id !== null);
          this.$emit('input', this.selected);
          this.$emit('selectChange', 'status_bilhete_multiple', this.selected);
        } else if (!hasAllOption && this.selected.length === this.options.length - 1) {
          // Tinha todos selecionados e desmarcou algo
          this.$emit('input', this.selected);
          this.$emit('selectChange', 'status_bilhete_multiple', this.selected);
        } else {
          // Seleção normal
          // Remove a opção "Todos" se estiver na seleção
          const filteredSelection = e.filter((item) => item.id !== null);
          this.selected = filteredSelection;
          this.$emit('input', this.selected);
          this.$emit('selectChange', 'status_bilhete_multiple', this.selected);
        }
      } else {
        // Nenhum selecionado
        this.$emit('input', []);
        this.$emit('selectChange', 'status_bilhete_multiple', []);
      }
    },
    labelStatusBilhete({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value && Array.isArray(value)) {
        this.selected = value;
        this.$emit('input', value);
        this.$emit('selectChange', 'status_bilhete_multiple', value);
      } else if (value) {
        // Se receber um único valor, converte para array
        const found = this.options.find((option) => option.id === value || option.id === value.id);
        if (found) {
          this.selected = [found];
          this.$emit('input', this.selected);
          this.$emit('selectChange', 'status_bilhete_multiple', this.selected);
        }
      } else {
        this.selected = [];
        this.$emit('input', []);
        this.$emit('selectChange', 'status_bilhete_multiple', []);
      }
    },
    clearAll() {
      this.selected = [];
      this.$emit('input', []);
      this.$emit('selectChange', 'status_bilhete_multiple', []);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('status_bilhete', { columns: 'id,status as nome', order: 'id' })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.allOption = { id: null, nome: this.$i18n.t(this.emptyLabel) };
            this.options = [this.allOption];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    removeOption(option) {
      if (!option) return;
      this.selected = this.selected.filter((item) => item.id !== option.id);
      this.$emit('input', this.selected);
      this.$emit('selectChange', 'status_bilhete_multiple', this.selected);
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove-icon {
  cursor: pointer;
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 2px;
  opacity: 0.7;
  transition: opacity 0.2s;
  line-height: 1;
}

.custom__remove-icon:hover {
  opacity: 1;
}
</style>

<style lang="scss">
.multiselect__tags {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 6px !important;
  min-height: 38px !important;
}

.badge-sm {
  font-size: 0.85rem;
  line-height: 1.2;
}
</style>
